import {
  FaImages, FaHome, FaPalette, FaWindowRestore, FaHeading, FaShareAlt, FaEnvelope,
  FaCrown, FaImage, FaAd, FaBomb, FaRocket, FaLayerGroup, FaStore, FaReceipt, FaCoins,
  FaGift, FaCalendarAlt, FaTicketAlt, FaUserFriends, FaTrophy, FaSyncAlt, FaUsers, FaShieldAlt
} from 'react-icons/fa';
import { SiKick } from 'react-icons/si';

// Single source of truth for the admin sidebar AND the overview launchpad, so both stay in sync.
export const ADMIN_MENU_GROUPS = [
  {
    key: 'content',
    label: 'Site İçeriği',
    icon: FaHome,
    items: [
      { path: '/admin/hero-carousel', label: 'Ana Reklam Kartı', icon: FaImages },
      { path: '/admin/homepage', label: 'Ana Sayfa Yönetimi', icon: FaHome },
      { path: '/admin/logo', label: 'Logo Yönetimi', icon: FaPalette },
      { path: '/admin/popups', label: 'Popup Yönetimi', icon: FaWindowRestore },
      { path: '/admin/sections', label: 'Başlık Yönetimi', icon: FaHeading },
      { path: '/admin/social-media', label: 'Sosyal Medya', icon: FaShareAlt },
      { path: '/admin/contacts', label: 'İletişim', icon: FaEnvelope }
    ]
  },
  {
    key: 'sponsors',
    label: 'Sponsorlar & Reklamlar',
    icon: FaCrown,
    items: [
      { path: '/admin/sponsors', label: 'Sponsorlar', icon: FaCrown },
      { path: '/admin/banners', label: 'Banner Yönetimi', icon: FaImage },
      { path: '/admin/sponsor-banners', label: 'Sponsor Banner Kart', icon: FaAd }
    ]
  },
  {
    key: 'games',
    label: 'Saguex Originals',
    icon: FaLayerGroup,
    items: [
      { path: '/admin/blackjack', label: 'Blackjack Ayarları', icon: FaLayerGroup },
      { path: '/admin/mines', label: 'Mines Ayarları', icon: FaBomb },
      { path: '/admin/limbo', label: 'Limbo Ayarları', icon: FaRocket }
    ]
  },
  {
    key: 'market',
    label: 'Market & Puan',
    icon: FaStore,
    items: [
      { path: '/admin/market', label: 'Market Yönetimi', icon: FaStore },
      { path: '/admin/market-purchases', label: 'Market Sipariş Geçmişi', icon: FaReceipt },
      { path: '/admin/coins', label: 'Puan Yönetimi', icon: FaCoins },
      { path: '/admin/promo-codes', label: 'Puan Kodu Yönetimi', icon: FaGift }
    ]
  },
  {
    key: 'events',
    label: 'Biletler & Etkinlikler',
    icon: FaTicketAlt,
    items: [
      { path: '/admin/ticket-events', label: 'Bilet Etkinlikleri', icon: FaCalendarAlt },
      { path: '/admin/tickets', label: 'Bilet Talepleri', icon: FaTicketAlt },
      { path: '/admin/referral-tickets', label: 'Referans Davetleri', icon: FaUserFriends },
      { path: '/admin/ticket-raffle', label: 'Çekiliş Yönetimi', icon: FaTrophy },
      { path: '/admin/spin-events', label: 'Çevrim Etkinliği', icon: FaSyncAlt }
    ]
  },
  {
    key: 'members',
    label: 'Üyelik & Güvenlik',
    icon: FaUsers,
    items: [
      { path: '/admin/users', label: 'Üye Yönetimi', icon: FaUsers },
      { path: '/admin/ips', label: 'IP Yönetimi', icon: FaShieldAlt }
    ]
  },
  {
    key: 'integrations',
    label: 'Entegrasyonlar',
    icon: SiKick,
    items: [
      { path: '/admin/kick', label: 'Kick Entegrasyonu', icon: SiKick }
    ]
  }
];

export const findAdminMenuItem = (pathname) => {
  for (const group of ADMIN_MENU_GROUPS) {
    const item = group.items.find((i) => pathname === i.path || pathname.startsWith(i.path + '/'));
    if (item) return { group, item };
  }
  return null;
};
